// extracted by mini-css-extract-plugin
module.exports = {"text-link":"TextLink_text-link__FKPuC"};